export default __webpack_public_path__ + "static/media/17.9f8d50b3.jpg";